export type CaptureStepId = 'spread' | 'registration' | 'selfie';

export type OverlayVariant = 'horizontal' | 'vertical' | 'selfie';

export type ImageSource = 'camera' | 'gallery';

export interface CaptureStepConfig {
  id: CaptureStepId;
  stepNumber: 1 | 2 | 3;
  title: string;
  hint: string;
  overlayVariant: OverlayVariant;
  facingMode: 'environment' | 'user';
}

export interface CapturedImage {
  id: CaptureStepId;
  blob: Blob;
  dataUrl: string;
  source: ImageSource;
}

export const CAPTURE_STEPS: CaptureStepConfig[] = [
  {
    id: 'spread',
    stepNumber: 1,
    title: 'Разворот',
    hint: 'Поместите разворот паспорта с фото в рамку. Убедитесь, что все данные читаются.',
    overlayVariant: 'horizontal',
    facingMode: 'environment',
  },
  {
    id: 'registration',
    stepNumber: 2,
    title: 'Регистрация',
    hint: 'Сфотографируйте страницу с регистрацией по месту жительства.',
    overlayVariant: 'vertical',
    facingMode: 'environment',
  },
  {
    id: 'selfie',
    stepNumber: 3,
    title: 'Селфи',
    hint: 'Держите паспорт внизу, лицо - в овале. Смотрите прямо в камеру.',
    overlayVariant: 'selfie',
    facingMode: 'user',
  },
];

export type WizardPhase = 'capture' | 'preview' | 'review';
